import FormField from "./FormField";
import { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { ProgressSpinner } from "primereact/progressspinner";
import Container from "./Container";
import Text from "./Text";
import Icon from "./Icon";
import { AssetSummary } from "../commons/assetSummary";
import { useFindAsset } from "../hooks/useFindAsset";
 
interface IAssetSearchSelectorProps {
    label: string;
    hasError?: boolean;
    error?: string;
    selected?: AssetSummary;
    onSelectBank: (bank: AssetSummary|null) => void;
}

const AssetSearchSelector = ({ hasError, error, label, selected, onSelectBank }: IAssetSearchSelectorProps) => {
    const { findAsset, assetList, isLoading, setAssetList } = useFindAsset();

    const [searchQueryTimeouted, setSearchQueryTimeouted] = useState<string>("");

    useEffect(() => {
        const timeout = setTimeout(() => {
            findAsset(searchQueryTimeouted);
        }, 1500);

        return () => clearTimeout(timeout);
    }, [searchQueryTimeouted]);

    return (
        <FormField
            id="asset"
            label={label}
            hasError={hasError}
            error={error}
        >
            <Container relative>
                <InputText 
                    value={selected?.name ?? searchQueryTimeouted}
                    className="w-full pr-5"
                    invalid={hasError}
                    onChange={(e) => {
                        setSearchQueryTimeouted(e.target.value);
                    }}
                />
                
                {
                    selected && <Icon 
                        name="pi-times"
                        className="absolute right-0 mr-1 p-2 text-red-500 bg-white"
                        onClick={() => {
                            onSelectBank(null);
                            setSearchQueryTimeouted("");
                            setAssetList([]);
                        }}
                        style={{ transform: "translateY(-50%)", top: "50%" }}
                    />
                }
            </Container>
            {
                isLoading && (
                    <Container center flexColumn className="my-progress-spinner p-4" gap={2}>
                        <ProgressSpinner className="w-2rem h-auto" />
                        <Text>Carregando...</Text>
                    </Container>       
                )
            }

            {
                !!assetList.length && !selected && searchQueryTimeouted && !isLoading && <div className="bg-white w-full">
                    <ul className="list-none p-0 mt-3 flex gap-2 flex-column">
                        {
                            assetList.map(f => {
                                return (
                                    <li key={f.id}>
                                        <a 
                                            className="cursor-pointer" 
                                            onClick={() => {
                                                onSelectBank(f);
                                            }}
                                        >
                                            {f.name}
                                        </a>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
            }
        </FormField>
    );
}

export default AssetSearchSelector;
